// Line breaker code
/**
 * Applies linebreakers manually based on original text length
 */
export function applyLinebreakers(copy: string, thresholds: number[]) {
    if(copy.includes("<br>")) {
        return copy;
    }
    let 
        total = thresholds.reduce((total, cur) => total + cur, 0),
        curString = "",
        threshold = thresholds[0],
        index = 0;

    // console.log(copy);
    for(let i = 0; i < thresholds.length; i++) {
        thresholds[i] = Math.floor(copy.length / total * thresholds[i]);
        // console.log(thresholds[i]);
    }

    for(let i = 0; i < copy.length; i++) {
        if(i > threshold && copy[i] === " " && index < thresholds.length - 1) {
            curString += "</br>";
            index += 1;
            threshold += thresholds[index];
            // console.log(threshold);
        } else {
            curString += copy[i];
        }
    }

    return curString;
}

export function maintainRows(copy: string, rowLength: number) {
    let 
        curString = "",
        curWord = "",
        index = 1;

    for(let i = 0; i < copy.length; i++) {
        // let lim = rowLength * index - (index === 1 ? 0 : 4);
        if(i > rowLength * index && copy[i] === " ") {
            curWord = "</br>" + curWord;
            index += 1;
            curString += curWord;
            curWord = "";
        }
        
        if (copy[i] === " ") {
            curWord += copy[i];
            curString += curWord;
            curWord = "";
        } else {
            curWord += copy[i];
            // console.log(curWord);
        }
    }
    curString += curWord;

    return curString
}
